import React, { Fragment, useEffect, useState, useContext } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate, useParams } from "react-router-dom";
import {
  createClientIdQueryString,
  sendApiRequest,
} from "../../services/Base/base-service";
import { notifyUser } from "../../services/helpers";

import SubNavigation from "../../components/Header/SubNavigation";
import UserContext from "../../store/user-context";
import ClientDocumentsConfigModal from "../../components/Modals/ClientDocumentsConfigModal";
import ConfirmModal from "../../components/Modals/ConfirmModal";
import ClientDocumentsConfigurationTable from "../../components/Tables/ClientDocumentsConfigurationTable";
import { Alert, NotificationManager, Section, Spinner } from "design-react-kit";
import Footer from "../../components/Footer";

const ClientDocumentsConfiguration = () => {
  const [documents, setDocuments] = useState(null);
  const [documentsNumber, setDocumentsNumber] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [documentsModalOpen, setDocumentsModalOpen] = useState(false);
  const [editableDocument, setEditableDocument] = useState(null);
  const [confirmModalOpen, setConfirmModalOpen] = useState(false);

  const userContext = useContext(UserContext);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const params = useParams();
  const clientId = params?.clientId;

  useEffect(() => {
    getClientDocumentRules();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getClientDocumentRules = () => {
    setIsLoading(true);
    setTimeout(() => {
      sendApiRequest(
        "ClientConfiguration/GetClientDocumentRules",
        "GET",
        true,
        { clientId },
        signIn,
        signOut,
        navigate,
        createClientIdQueryString,
        userContext
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setDocuments(response.data.clientDocumentRules);
            setIsLoading(false);
          }
        }
      });
    }, 400);
  };

  useEffect(() => {
    setTimeout(() => {
      sendApiRequest(
        "ClientConfiguration/GetSupportedDocumentTypes",
        "GET",
        true,
        { clientId },
        signIn,
        signOut,
        navigate,
        createClientIdQueryString,
        userContext
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setDocumentsNumber(response.data.supportedDocumentTypes.length);
            setIsLoading(false);
          }
        }
      });
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const documentsModalOpenHandler = (item) => {
    setDocumentsModalOpen(true);
    setEditableDocument(item);
  };

  const documentsModalCloseHandler = () => {
    getClientDocumentRules();
    setDocumentsModalOpen(false);
  };

  const confirmModalCloseHandler = () => {
    getClientDocumentRules();
    setConfirmModalOpen(false);
  };

  const confirmModalOpenHandler = (doc) => {
    setEditableDocument(doc);
    setConfirmModalOpen(true);
    setTimeout(() => {
      document.querySelector(".modal-email").textContent = doc.documentTypeName;
    }, 600);
  };

  return (
    <Fragment>
      <SubNavigation
        page="clientDocumentsConfiguration"
        openModalHandler={documentsModalOpenHandler}
        documentsNumber={documentsNumber}
      />
      <Section>
        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
        {isLoading && (
          <p
            style={{
              height: "50px",
              position: "relative",
              marginBottom: "3rem",
            }}
          >
            <Spinner double active />
          </p>
        )}
        {error === null && !isLoading && (
          <ClientDocumentsConfigurationTable
            items={documents}
            columns={[
              {
                name: "Documento",
                type: "string",
                sortable: true,
                value: "documentTypeName",
              },
              {
                name: "Numero minimo documenti",
                type: "number",
                sortable: false,
                value: "",
              },
              {
                name: "Numero massimo documenti",
                type: "number",
                sortable: false,
                value: "",
              },
              {
                name: "Da allegare",
                type: "bool",
                sortable: false,
                value: "",
              },
              {
                name: "Da analizzare",
                type: "bool",
                sortable: false,
                value: "",
              },
              {
                name: "Azioni",
                type: "",
                sortable: false,
                value: "",
              },
            ]}
            documentsModalOpenHandler={documentsModalOpenHandler}
            confirmModalOpenHandler={confirmModalOpenHandler}
            getClientDocumentRules={getClientDocumentRules}
          />
        )}
      </Section>
      <ClientDocumentsConfigModal
        modalOpen={documentsModalOpen}
        modalCloseHandler={documentsModalCloseHandler}
        editableDocument={editableDocument}
        notifyUser={notifyUser}
        setDocuments={setDocuments}
        setDocumentsNumber={setDocumentsNumber}
      />
      <ConfirmModal
        confirmModalOpen={confirmModalOpen}
        confirmModalCloseHandler={confirmModalCloseHandler}
        notifyUser={notifyUser}
        method={"deleteClientDocumentRuleHandler"}
        text={"Stai per eliminare l'documento"}
        setDocuments={setDocuments}
        clientDocumentRuleId={editableDocument?.clientDocumentRuleId}
        clientId={clientId}
        setDocumentsNumber={setDocumentsNumber}
      />
      <div>
        <NotificationManager
          containerId="esempio-avanzato"
          fix="right"
          closeOnClick={true}
          state="success"
          duration={30000}
        />
      </div>
      <Footer />
    </Fragment>
  );
};

export default ClientDocumentsConfiguration;
